
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.e44befa3.svg#" + id;
};
          